import React, { useMemo, useState } from 'react';
import LateralPanel from '../../../../../../muiComponents/LateralPanel';
import IconButton from '../../../../../../muiComponents/IconButton';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoActivityLogs } from '../../../../contexts/ZitoneoContentContext';
import { ConnectivityLogsSortState } from '../../../../types/zitoneoServicesTypes';
import {
    CONNECTIVITY_LOGS_SORT_DEFAULT,
    buildAgencyLogGroups,
    sortAgencyLogGroups,
} from '../../../../utils/zitoneoServicesUtils';
import ConnectivityLogsAgency from './ConnectivityLogsAgency';
import ConnectivityLogsSort from './ConnectivityLogsSort';
import '../../../../stylesheets/connectivity-logs-panel.scss';

interface ConnectivityLogsPanelProps {
    open: boolean;
    onClose: () => void;
}

const ConnectivityLogsPanel = ({
    open,
    onClose,
}: ConnectivityLogsPanelProps) => {
    const translate = useTranslate();
    const { ActivityLogs } = useZitoneoActivityLogs();
    const [sortedBy, setSortedBy] = useState<ConnectivityLogsSortState>(
        CONNECTIVITY_LOGS_SORT_DEFAULT
    );

    const agencyGroups = useMemo(
        () => buildAgencyLogGroups(ActivityLogs),
        [ActivityLogs]
    );

    const sortedAgencyGroups = useMemo(
        () => sortAgencyLogGroups(agencyGroups, sortedBy),
        [agencyGroups, sortedBy]
    );

    return (
        <LateralPanel
            anchor='left'
            open={open}
            onClose={onClose}
            className='connectivity-logs-panel padding40'
        >
            <header className='flex flex-between flex-align-center'>
                <h1 className='lateral-panel__title'>
                    {translate('api_connectivity')}
                </h1>
                <div className='flex flex-align-center gap-20'>
                    <ConnectivityLogsSort
                        sortedBy={sortedBy}
                        onChange={setSortedBy}
                    />
                    <IconButton iconName='Close' onClick={onClose} />
                </div>
            </header>
            <main className='flex-column gap-20 height100perc overflow-y-auto overflow-x-hidden padding-top-16'>
                {sortedAgencyGroups.map(({ agency, types }) => (
                    <ConnectivityLogsAgency
                        key={agency}
                        agency={agency}
                        types={types}
                    />
                ))}
            </main>
        </LateralPanel>
    );
};

export default ConnectivityLogsPanel;
